import { SwiperOptions } from "swiper/types";
import Swiper from "swiper";
import { getRefs, updateChildren } from "./utils";
import { ref, watch, h } from "vue";

interface CarouselProps {
  rootEl: HTMLElement;
}

const Carousel = (props: CarouselProps) => {
  const options: SwiperOptions = {
    speed: 1000,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    spaceBetween: 8,
  };

  const refs = getRefs(props.rootEl);

  const swiper = new Swiper(props.rootEl, options);

  // Handle arrow navigation if present
  refs.arrowLeft?.addEventListener("click", () => {
    swiper.slidePrev();
  });

  refs.arrowRight?.addEventListener("click", () => {
    swiper.slideNext();
  });

  if (!refs.controls) return;

  const swiperState = ref({
    currentPage: 0,
    totalPages: swiper.snapGrid.length,
  });

  swiper.on("slideChange", () => {
    swiperState.value.currentPage = swiper.realIndex;
  });
  swiper.on("resize", () => {
    swiperState.value.totalPages = swiper.snapGrid.length;
  });

  watch(
    () => swiperState.value,
    (value) => {
      if (!refs.controls) return;

      const children = [];

      for (let i = 0; i < value.totalPages; i++) {
        const dot = document.createElement("div");
        dot.classList.add("carousel--dot");

        if (i === value.currentPage) {
          dot.setAttribute("aria-current", "true");
        }

        children.push(dot);
      }

      updateChildren(refs.controls, children);
    },
    { immediate: true, deep: true }
  );
};

const init = () => {
  const carousels = document.querySelectorAll<HTMLElement>("[h-comp='carousel']");

  for (const carousel of carousels) {
    Carousel({ rootEl: carousel });
  }
};

init();
